import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GTMTracking } from '@common/ui/general';

import { isNullOrUndefined } from '@common/utils/type';
import { gtmEventHandler } from '@common/utils/gtm';

import { toast } from '@common/ui/general/Toast';

import { getACSStatus, requestACS } from '@alumni_v2/api/acsConnect';
import {
  getInitialResources,
  setIsSignupSidebarOpen,
} from '@alumni_v2/stores/reviews/actions';
import { isUserLoggedIn } from '@alumni_v2/utils/helpers';

const ConnectWithAlumniButton = ({
  children,
  className,
  gtmEventData,
  name,
  onClick,
  setSidebarModalStage,
  onModalClose,
  userId,
  context = '',
}) => {
  const dispatch = useDispatch();
  const {
    crtCompleted, setCompleted, menteeId,
  } = useSelector((state) => ({
    crtCompleted: state.reviews.crtCompleted,
    setCompleted: state.reviews.setCompleted,
    menteeId: state.reviews.menteeId,
  }));

  const checkAndRequestACS = async () => {
    const acsStatus = await getACSStatus();
    let success = true;
    let message = 'ACS Already Placed';

    if (acsStatus.registered === false) {
      const result = await requestACS({ alumni_id: userId });
      success = result.success;
      message = success ? 'ACS Successfully Placed' : 'ACS request failed';

      if (!success) {
        toast.show({
          message: 'ACS request failed. Please try again later.',
          type: 'error',
          duration: 5000,
        });
      }
    }

    gtmEventHandler(
      'cta',
      acsStatus.registered
        ? 'acs_modal_button_already_placed'
        : 'acs_modal_button_request_status',
      'click',
      'alumni_directory',
      {
        form_status: success,
        message,
      },
    );
  };

  const refetchInitialResources = async () => {
    await dispatch(getInitialResources());
  };

  const trackModalViewStage = (stage) => {
    gtmEventHandler(
      'cta',
      `acs_${stage}_modal_view`,
      'click',
      'alumni_directory',
    );
  };

  const triggerAuthFlow = () => {
    dispatch(setIsSignupSidebarOpen(true));
    document.getElementsByClassName('alumni-v2-auth-trigger')[0].click();
  };

  /**
   * If logged In:
    * Check if ACS requested, if no, then request ACS.
    * Once ACS is placed, then next stages will be:
    *   1. Refetch the status of CRT and SET
    *   2. Check if CRT done
    *   3. Check if SET done
    *   4. If everything done, then show Thank You screen
  * else
    * Trigger Login FLow
  */
  const onButtonClick = async () => {
    if (isUserLoggedIn()) {
      await checkAndRequestACS();
      await refetchInitialResources();

      if (onClick) onClick();

      if (!crtCompleted) {
        trackModalViewStage('crt');
        setSidebarModalStage(1);
        return;
      }

      if (isNullOrUndefined(menteeId)) {
        trackModalViewStage('success');
        setSidebarModalStage(3);
        return;
      }

      if (!setCompleted) {
        trackModalViewStage('set');
        setSidebarModalStage(2);
        return;
      }

      trackModalViewStage('success');
      setSidebarModalStage(3);
    } else {
      onModalClose();
      sessionStorage.setItem('requested-acs', true);
      triggerAuthFlow();
    }
  };

  return (
    <GTMTracking
      component={context === 'vd-ds-btn' ? 'div' : 'button'}
      gtmEventType="cta"
      gtmEventAction="click"
      gtmEventResult="acs_modal_button_clicked"
      gtmEventCategory="alumni_directory"
      className={className}
      onClick={onButtonClick}
      tabIndex={-1}
      role="button"
      gtmEventData={{
        click_type: 'acs_modal_button_clicked',
        click_text: name,
        click_section: 'card_details',
        ...gtmEventData,
      }}
    >
      {children}
    </GTMTracking>
  );
};

export default ConnectWithAlumniButton;
